import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCJytgbAfrq_MyNABA0JpKnwp-W9d08ntI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "avito-annonces.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "avito-annonces",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "avito-annonces.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "723247883855",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:723247883855:web:12a8caf105905083f72c3a",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-WGCSS31K5D"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;